/*
 * Copyright (c) 2020  Apricad LLC. All Rights Reserved.
 */

import { niceScrollbar } from "assets/jss/views/classroomPage/classroomStyle";
import {
  dlgTitle,
  studyDlg,
  titleText,
} from "assets/jss/views/studyPage/studyPageStyle";
import {
  pageBackground,
  container,
  contentBox,
  title,
} from "assets/jss/views/legalPage/legalPageStyle";
import { mlTextBox } from "assets/jss/views/coursePage/postsStyle";
import { inputErrorStyle } from "assets/jss/views/accountPage/accountPageStyle";

const mainImg = require("assets/img/desk3.jpg");

const donateOpt = {
  "@media (min-width: 411px)": {
    width: "5.5rem",
    height: "5rem",
  },
  "@media (min-width: 731px)": {
    width: "9.5rem",
    height: "8.5rem",
    padding: "1rem",
  },
  width: "4rem",
  height: "4rem",
  margin: "auto",
  padding: "0.25rem",

  backgroundColor: "white",
  borderRadius: "0.5rem",
  position: "relative",
};

const donateNum = {
  "@media (min-width: 600px)": {
    fontSize: "2rem",
  },
  fontSize: "1.2rem",
  fontWeight: 500,
  // hide the inc/dec arrow of TextInput for number
  "&::-webkit-inner-spin-button,&::-webkit-outer-spin-button": {
    "-webkit-appearance": "none",
    margin: 0,
  },
  "-moz-appearance": "textfield",
};

const styles = (theme) => {
  return {
    "@global": niceScrollbar,

    dlgTitle,
    surveyDlg: {
      ...studyDlg,
      "& h4, h5, h6": { fontFamily: "Open Sans", textTransform: "none" },
    },
    titleText,
    inputError: inputErrorStyle,
    mlTextBox,

    pageBackground,
    container: {
      ...container,
      backgroundColor: theme.palette.paper.light,
    },
    contentBox,
    title,

    btnCenter: {
      margin: "0 auto 1rem",
      display: "flex",
      justifyContent: "center",
    },

    donateOpts: {
      "@media (min-width: 1024px)": {
        width: "75%",
      },
      width: "100%",
      margin: "0 auto",
    },

    donateOptSel: {
      ...donateOpt,
      border: `4px solid ${theme.palette.info.dark}`,
    },
    donateOptUn: {
      ...donateOpt,
      border: `2px solid #B0B0B0`,
      "&:hover": {
        border: `4px solid ${theme.palette.info.light}`,
      },
    },

    donateImg: {
      "@media (min-width: 411)": {
        bottom: "0.5rem",
        right: "0.5rem",
      },
      bottom: "2px",
      right: "2px",

      width: "80%",
      position: "absolute",
    },

    donateNum,
  };
};

export default styles;
